import { styled, Box } from '@mui/material';
import { SIDEBAR_ITEM_COLORS } from './constants.js';

const ItemWrapper = styled(Box)(({ theme, $isActive }) => (Object.assign({ backgroundColor: theme.palette.dui10, color: theme.palette.text.dmedium, margin: 0, padding: theme.spacing(1.5, 2), display: "flex", justifyContent: "space-between", alignItems: "center", borderRadius: "8px", cursor: "pointer", "&:hover": {
        backgroundColor: SIDEBAR_ITEM_COLORS.hover,
    }, "&:active": {
        backgroundColor: SIDEBAR_ITEM_COLORS.pressed,
    } }, ($isActive && {
    backgroundColor: SIDEBAR_ITEM_COLORS.active,
}))));

export { ItemWrapper };
//# sourceMappingURL=ItemWrapper.js.map
